@if (show) {
  <mat-progress-bar class="top-bar" [mode]="mode" [value]="progress"></mat-progress-bar>

  <div class="overlay-blocker"></div>
}
